export const getFormReducer = (state) => state.form
export const getOpenForWorkForm = (state) => state.form.openforwork.loadData
export const getOpenWorkAttachments = (state) =>
  state.form.openforwork.loadData.OpenWorkAttachments
export const getApplicationData = (state) => state.openForWork.applicationData
export const getPhoneNumber = (state) => state.profile.userData.phone

export const getUserData = (state) => state.client.user.data
export const getProfileData = (state) => state.profile.userData

export const getJournalId = (state) => state.form.timeReport.loadData.journal_id
export const getIsEditTimeReportData = (state) => state.form.timeReport.loadData

export const getPrevLocation = (state) =>
  state.router.previousLocations[1].location.pathname

export const getDirectlyOfferedAssignmentId = (state) =>
  state.assignment.directlyOfferedAssignmentId
export const getAssignmentRows = (state) => state.assignment.assignmentRows
export const getAppliedAssignmentId = (state) =>
  state.assignment.appliedAssignmentId
export const getAppliedData = (state) => state.assignment.appliedData

export const getMyAssignmentRows = (state) => state.assignment.myAssignmentRows

export const getWorkShiftUserRow = (state) =>
  state.workShiftUser.workShiftUserRow
